import cn from 'classnames';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { Label } from '@creditflowresearch/uilib/Badge/Label';
import ISubsector from '@/creditflowresearch/domain/vo/ISubsector';
import ISector from '@/creditflowresearch/domain/vo/IDealSector';
import ISubindustry from '@/creditflowresearch/domain/vo/ISubindustry';
import IIndustry from '@/creditflowresearch/domain/vo/IIndustry';

import styles from './styles.module.scss';

const getSectorIndustryTooltipContent = (
  sectorOrIndustryName: string,
  subsectorsOrSubindustries: ISubsector | ISubindustry) => {
  if (!subsectorsOrSubindustries) {
    return (
      <div className={ styles.tooltipContent }>
        { sectorOrIndustryName }
      </div>
    );
  }

  return (
    <div className={ styles.tooltipContent }>
      <p className={ styles.tooltipItem }>{ `${ sectorOrIndustryName }: ${ subsectorsOrSubindustries.name }` }</p>
    </div>
  );
};

interface IProps {
  sectorOrIndustry: IIndustry | ISector,
  subsectorOrSubindustry: ISubindustry | ISubsector,
  className?: string,
}

const SectorIndustryLabel = ({
  sectorOrIndustry,
  subsectorOrSubindustry,
  className,
}: IProps) => {
  if (!sectorOrIndustry) {
    return null;
  }
  return (
    <div data-test="sectorIndustryLabel">
      <Tooltip
        content={ getSectorIndustryTooltipContent(sectorOrIndustry.name, subsectorOrSubindustry) }
      >
        <Label
          className={ cn(styles.label, className) }
          backgroundColor={ sectorOrIndustry.color }
        >
          { sectorOrIndustry.abbreviation }
        </Label>
      </Tooltip>
    </div>
  );
};

export default SectorIndustryLabel;
